import { Controller } from "@hotwired/stimulus"
import { toggleSectionVisibility } from "../src/toggle_section_visibility"

export default class extends Controller {
  static targets = ["source", "section", "hiddenInput"]

  connect() {
    this.sync()
  }

  sync() {
    const value = this.currentValue()

    this.syncHiddenInput()

    this.sectionTargets.forEach((section) => {
      this.toggleSection(section, this.matches(section, this.sectionValue(section, value)))
    })
  }

  sectionValue(section, value) {
    const { sectionVisibilityField } = section.dataset
    if (!sectionVisibilityField) return value

    return this.element.querySelector(sectionVisibilityField)?.value || null
  }

  currentValue() {
    const source = this.hasSourceTarget ? this.sourceTarget : this.element

    if (source.matches("input, select, textarea")) {
      if (source.type === "checkbox" || source.type === "radio") {
        return source.checked ? source.value : (source.dataset.sectionVisibilityUncheckedValue || null)
      }

      return source.value
    }

    const checked = Array.from(
      source.querySelectorAll("input[type='radio']:checked, input[type='checkbox']:checked")
    )

    if (checked.length > 1) return checked.map((input) => input.value)

    return checked[0]?.value || null
  }

  matches(section, value) {
    const currentValues = Array.isArray(value) ? value : [value]
    const { sectionVisibilityValues, sectionVisibilityHiddenValues } = section.dataset

    if (sectionVisibilityHiddenValues !== undefined) {
      return !this.includesAny(sectionVisibilityHiddenValues, currentValues)
    }

    return this.includesAny(sectionVisibilityValues, currentValues)
  }

  includesAny(values, currentValues) {
    const sectionValues = (values || "").split(/[,\s]+/).filter(Boolean)

    return currentValues.some((currentValue) => sectionValues.includes(currentValue))
  }

  syncHiddenInput() {
    if (!this.hasHiddenInputTarget) return

    this.hiddenInputTarget.value = this.hiddenInputValue()
  }

  toggleSection(section, visible) {
    toggleSectionVisibility(section, visible)
    section.dispatchEvent(new CustomEvent("section-visibility:changed", {
      bubbles: true,
      detail: { visible }
    }))
  }

  hiddenInputValue() {
    const source = this.hasSourceTarget ? this.sourceTarget : this.element

    if (source.matches("input[type='checkbox'], input[type='radio']")) {
      return source.checked ?
        (source.dataset.sectionVisibilityCheckedValue || source.value) :
        (source.dataset.sectionVisibilityUncheckedValue || "")
    }

    const value = this.currentValue()
    return Array.isArray(value) ? (value[0] || "") : (value || "")
  }

}
